import React, { lazy, Suspense } from 'react'
import { SwiftMenu } from '../SwiftMenu'
import { FilterMenu } from '../FilterMenu'
import MediaView from './mediaView'
import { FileDropZone } from './FileDropZone'
import { MediaDragLayer } from './DragLayer'
import { css } from 'aphrodite'
import styles from './styles'

const TagMenu = lazy(() => import('../TagMenu/tagMenu'))

const MediaWrapper = () => {
  return (
    <div className={css(styles.mediaWrapper)}>
      <FileDropZone>
        <MediaView />
      </FileDropZone>
      <SwiftMenu />
      <Suspense fallback={null}>
        <TagMenu />
      </Suspense>
      <FilterMenu />
      <MediaDragLayer />
    </div>
  )
}

export default MediaWrapper



// WEBPACK FOOTER //
// ./src/components/Media/mediaWrapper.js